import { Component } from '@angular/core';
import { BingMapsLoader } from '../../services/map-loader.service';
@Component({
  selector: 'app-geo-portal',
  templateUrl: './geo-portal.component.html',
  styleUrls: ['./geo-portal.component.scss']
})
export class GeoPortalComponent {
  mapReady = false;
  constructor() {
  BingMapsLoader.load()
  .then(res => {
      console.log('BingMapsLoader.load.then', res);
      this.mapReady = true;
    });
  }
}
